import background from './background';
import inView from './viewport';
import equalize from './matchHeight';

export default function syncPostsHandler () {
    const base = document.querySelector('#sync-posts-wrapper');
    const themePath = document.querySelector('meta[name="theme-path"]').content;
    const paged_posts_data = [];
    let initialPage = 1;

    if (!base) {
        return;
    }

    // Ensure posts_data is defined globally
    if (typeof posts_data === 'undefined') {
        // eslint-disable-next-line no-undef
        console.error('posts_data is undefined.');
        return;
    }

    // Split posts_data into pages (arrays of 9 posts each)
    // eslint-disable-next-line no-undef
    for (let i = 0; i < posts_data.length; i += ppp) {
        // eslint-disable-next-line no-undef
        paged_posts_data.push(posts_data.slice(i, i + ppp));
    }
    const totalPages = paged_posts_data.length;

    // Determine initial page based on URL hash, default to 1 if none found.
    if (window.location.hash) {
        const match = window.location.hash.match(/^#page-(\d+)$/);

        if (match && match[1]) {
            const hashPage = parseInt(match[1], 10);

            if (!isNaN(hashPage) && hashPage >= 1 && hashPage <= totalPages) {
                initialPage = hashPage;
            }
        }
    }

    // eslint-disable-next-line no-console
    // console.log(paged_posts_data);

    // Function to render a single post card as HTML
    const renderPostCard = item => {
        const date = new Date(item.date);
        const options = { month: 'long', year: 'numeric' };
        const formattedDate = date.toLocaleDateString('pl-PL', options);

        return `
            <div class="columns small-12 large-4">
                <div class="post-card" data-view="1">
                    <a class="post-thumbnail" href="${item.link}" target="_blank" rel="noindex nofollow" title="${item.title.rendered}">
                        <span data-bg="${item.featured_image_url}"></span>
                    </a>
                    <div class="post-content">
                        <span class="entry-date">${formattedDate}</span>
                        <div class="block relative" data-equalize="post-card-content">
                            <h3 class="entry-title">
                                <a href="${item.link}" target="_blank" rel="noindex nofollow">${item.title.rendered}</a>
                            </h3>
                            ${item.excerpt.rendered}
                        </div>
                        <a href="${item.link}" class="read-more icon icon-arrow-right" target="_blank" rel="noindex nofollow" title="Czytaj więcej">
                            Czytaj więcej
                        </a>
                    </div>
                </div>
            </div>`;
    };

    // Function to render dynamic pagination markup
    const renderPagination = (activePage, total) => {
        let markup = `
    <div class="spacer s2"></div>
    <div class="row">
        <div class="small-12 columns">
            <nav class="paging" data-view="3">
                <ul>`;

        // Previous Page
        if (activePage > 1) {
            markup += `
            <li class="prev-page">
                <a href="#" title="Poprzednia strona">
                    <img src="${themePath}/assets/img/acf/arrow-left.svg" alt="Icon">
                </a>
            </li>`;
        }

        // First Page
        markup += (activePage === 1)
            ? `<li class="current"><a href="#">1</a></li>`
            : `<li><a href="#">1</a></li>`;

        // Ellipsis after first page
        if (activePage > 3) {
            markup += `<li class="dots">…</li>`;
        }

        // Middle range: activePage -1, activePage, activePage +1
        const startPage = Math.max(2, activePage - 1);
        const endPage = Math.min(total - 1, activePage + 1);

        for (let i = startPage; i <= endPage; i++) {
            if (i === 1 || i === total) continue; // Already handled
            markup += (i === activePage)
                ? `<li class="current"><a href="#">${i}</a></li>`
                : `<li><a href="#">${i}</a></li>`;
        }

        // Ellipsis before last page
        if (activePage < total - 2) {
            markup += `<li class="dots">…</li>`;
        }

        // Last Page
        if (total > 1) {
            markup += (activePage === total)
                ? `<li class="current"><a href="#">${total}</a></li>`
                : `<li><a href="#">${total}</a></li>`;
        }

        // Next Page
        if (activePage < total) {
            markup += `
            <li class="next-page">
                <a href="#" title="Następna strona">
                    <img src="${themePath}/assets/img/acf/arrow-right.svg" alt="Icon">
                </a>
            </li>`;
        }

        // Go-to form
        markup += `
        <li class="go-to-page">
            <form class="pagination-form">
                <label for="page_input">idź do strony</label>
                <input type="number" id="page_input" name="paged" value="${activePage}" min="1" max="${total}">
                <button type="submit" class="arrow-button primary" data-icon-type="arrow-right">
                    <img src="${themePath}/assets/img/acf/arrow-right.svg" alt="Icon">
                </button>
            </form>
        </li>
                </ul>
            </nav>
        </div>
    </div>`;

        return markup;
    };

    // Function to attach click handlers to pagination elements
    const attachPaginationHandlers = (activePage) => {
        const paginationNav = base.querySelector('nav.paging');

        if (!paginationNav) {
            return;
        }

        // Previous Page Link
        const prevLink = paginationNav.querySelector('li.prev-page a');

        if (prevLink) {
            prevLink.addEventListener('click', e => {
                e.preventDefault();
                updatePage(activePage - 1);
            });
        }

        // Next Page Link
        const nextLink = paginationNav.querySelector('li.next-page a');

        if (nextLink) {
            nextLink.addEventListener('click', e => {
                e.preventDefault();
                updatePage(activePage + 1);
            });
        }

        // Page number links
        const pageLinks = paginationNav.querySelectorAll('ul li:not(.prev-page):not(.next-page):not(.go-to-page) a');

        pageLinks.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();
                const page = parseInt(link.textContent, 10);

                updatePage(page);
            });
        });

        // Go-to-page form
        const gotoForm = paginationNav.querySelector('li.go-to-page form');

        if (gotoForm) {
            gotoForm.addEventListener('submit', e => {
                e.preventDefault();
                const input = gotoForm.querySelector('#page_input');
                const page = parseInt(input.value, 10);

                if (page >= 1 && page <= totalPages) {
                    updatePage(page);
                }
            });
        }
    };

    // Function to render posts for a given page number
    const renderPostsByPageNumber = (pagedData, activePage) => {
        // Clear base content
        base.innerHTML = '';

        // Create a container for the row of posts
        const row = document.createElement('div');

        row.classList.add('row');

        // Convert activePage to a zero-based index for array access
        const pageIndex = activePage - 1;

        // Loop through posts for the specified page and append each post card's HTML
        pagedData[pageIndex].forEach(item => {
            row.innerHTML += renderPostCard(item);
        });

        // Append the row to the base element
        base.appendChild(row);

        // Append the pagination markup
        base.insertAdjacentHTML('beforeend', renderPagination(activePage, totalPages));

        // Attach click handlers to pagination elements
        attachPaginationHandlers(activePage);

        // Initialize plugins after rendering posts
        equalize();
        background();
        inView();
    };

    // Function to update the page by re-rendering posts, pagination, scrolling, and updating URL hash
    function updatePage (newPage) {
        if (newPage < 1 || newPage > totalPages) {
            return;
        }

        // Update URL hash
        window.location.hash = `page-${newPage}`;
        renderPostsByPageNumber(paged_posts_data, newPage);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // Initial render
    renderPostsByPageNumber(paged_posts_data, initialPage);
}
